export default __webpack_public_path__ + "static/media/sliderImg3.2edc809e.jpg";